import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule,
} from '@domain-group/suit-theme'

import useBrandColour from '@hooks/useBrandColour'
import useBrandColours from '@hooks/useBrandColours'

import BrandColourListItem from './BrandColourListItem'

const BrandColours = (props) => {
  const { brand } = props

  const brandColourPayload = useBrandColour({ brand_id: brand.id })
  const {
    callbacks: { createOrEditBrandColour },
  } = brandColourPayload

  const brandColoursPayload = useBrandColours({
    filters: { brand_id: brand.id },
    performHttpRequests: !!brand,
  })

  const {
    filteredBrandColours,
    hasFilteredBrandColours,
    loading,
  } = brandColoursPayload

  return (
    <DashboardModule loading={loading} title="Brand Print Colours">
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {filteredBrandColours.map(brandColour => (
            <BrandColourListItem key={brandColour.id} brandColour={brandColour} />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer boxProps={{ borderTop: !hasFilteredBrandColours ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditBrandColour()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Colour
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

BrandColours.propTypes = {
  brand: PropTypes.object.isRequired,
}

export default BrandColours
